import {
  RequirementConditionOperator,
  RequirementConditionType
} from 'generated-graphql/types';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export const getAnalysisAutomationRequirementsMetOperator = (
  analysisAutomationItem: AutomationFormItem
): RequirementConditionOperator => {
  const condition = analysisAutomationItem.requirementConditions.find(
    (condition) =>
      condition.type ===
      RequirementConditionType.CandidateRequirementsMetCondition
  );
  return condition?.operator || RequirementConditionOperator.IsTrue;
};
